import {client, handleDataOrError} from '@freckle/educator-entities/ts/fancy-api-client'

export const DEFAULT_COURSE_QUERY_KEY = 'fetchDefaultCourseIdForTeacher'

export const fetchDefaultCourseIdForTeacher = (): Promise<number> =>
  client.GET('/3/teachers/me/default-course-id').then(handleDataOrError)
